<template>
  <div class="paper-image">
    <div
      v-if="isActivePeriod.index < periodData.length - 1"
      class="content-1__films__previous"
      @click="nextPeriod"
    >
      <img
        :src="require('@/assets/style/desktop/img/slider-left.svg')"
        alt=""
      >
    </div>
    <div
      v-if="isActivePeriod.index != 0"
      class="content-1__films__next"
      @click="previousPeriod"
    >
      <img
        :src="require('@/assets/style/desktop/img/slider-right.svg')"
        alt=""
      >
    </div>
    <div class="content-1__films" style="min-height: 800Px;">
      <div class="six-imgbox__img">
        <transition name="fade" mode="out-in">
          <div
            v-if="currentCanvasNewsURL === ''"
            class="paper-loading-text"
          >
            <span v-if="paperFetchMessage === ''">
              加载中
            </span>
            <span v-else>
              {{ paperFetchMessage }}
            </span>
          </div>
          <div v-else class="image-wrapper">
            <el-image
              :key="period"
              :src="currentCanvasNewsURL"
              :preview-src-list="[currentCanvasNewsURL]"
            />
          </div>
        </transition>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'PaperImage',
  props: {
    period: {
      type: String,
      required: true,
      default: () => ''
    },
    isActivePeriod: {
      type: Object,
      default: () => ({
        index: 0
      })
    },
    periodData: {
      type: Array,
      default: () => []
    },
    nextPeriod: {
      type: Function,
      default: () => {}
    },
    previousPeriod: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    currentCanvasNewsURL() {
      return this.$store.state.lottery.currentCanvasTukuURL
    },
    paperFetchMessage() {
      return this.$store.state.lottery.paperFetchMessage
    }
  }
}
</script>
<style lang="scss" scoped>
.paper-image {
  .el-image {
    display: block;
  }
}
.content-1__films {
  z-index: 3;
  border: 0;
  width: 1000PX;
  margin: 0 auto;
}

.image-wrapper {
  position: relative;
  width: 1000PX;
  margin: 0 auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
